import { DefaultState, IState } from "./state";
import { Keys, Types } from "./actions/types";
import { subscription } from "../../../model/subscription";
import { contactInsurance, contactMedicalExamination, contactPurchased, contactSubscription } from "../../../model/contactsubscription";

export const reducer = (state: IState = DefaultState(), action: Types): IState => {
	switch (action.type) {
		case Keys.CLEARPURCHASED: {
			return {
				...state,
				contactSubscriptions: undefined,
				contactInsurances: undefined,
				contactMedical: undefined,
			}
		}
		// LOAD CONTACT SUBSCRIPTION
		case Keys.LOADCONTACTPURCHASED_PENDING: {
			return {
				...state,
				contactSubscriptions: [],
				contactInsurances: [],
				contactMedical: [],
				isLoading: true,
			}
		}
		case Keys.LOADCONTACTPURCHASED_FULFILLED: {
			let p: contactPurchased = action.payload;
			return {
				...state,
				contactSubscriptions: p.subscriptions,
				contactInsurances: p.insurances,
				contactMedical: p.medicalExaminations,
				isLoading: false,
			}
		}
		case Keys.LOADCONTACTPURCHASED_REJECTED: {
			return {
				...state,
				contactSubscriptions: undefined,
				contactInsurances: undefined,
				contactMedical: undefined,
				isLoading: false,
			}
		}
		// SAVE
		case Keys.SAVECONTACTSUBSCRIPTION_PENDING: {
			return state;
		}
		case Keys.SAVECONTACTSUBSCRIPTION_FULFILLED: {
			let p: contactSubscription = action.payload; // sanifyContact();
			let cSubscription = [...state.contactSubscriptions];
			let found = cSubscription.findIndex(c => c._id === p._id);
			if (found >= 0) {
				cSubscription[found] = p;
			}
			return {
				...state,
				contactSubscriptions: cSubscription,
			}
		}
		case Keys.SAVECONTACTSUBSCRIPTION_REJECTED: {
			return state;
		}
		// REMOVE SINGLE ACCESS
		case Keys.REMOVEACCESSCONTACTSUBSCRIPTION_PENDING: {
			return state;
		}
		case Keys.REMOVEACCESSCONTACTSUBSCRIPTION_FULFILLED: {
			let p: contactSubscription = action.payload; // sanifyContact();
			let cSubscription = [...state.contactSubscriptions];
			let found = cSubscription.findIndex(c => c._id === p._id);
			if (found >= 0) {
				cSubscription[found] = p;
			}
			return {
				...state,
				contactSubscriptions: cSubscription,
			}
		}
		case Keys.REMOVEACCESSCONTACTSUBSCRIPTION_REJECTED: {
			return state;
		}
		// DELETE
		case Keys.DELETECONTACTSUBSCRIPTION_PENDING: {
			return state;
		}
		case Keys.DELETECONTACTSUBSCRIPTION_FULFILLED: {
			let saved: { id: string, deleted: boolean } = action.payload;
			let cSubscription = [...state.contactSubscriptions];
			if (saved.deleted) {
				let found = cSubscription.findIndex(c => c._id === saved.id);
				if (found >= 0) {
					cSubscription.splice(found, 1);
				}
			}
			return {
				...state,
				contactSubscriptions: cSubscription,
			}
		}
		case Keys.DELETECONTACTSUBSCRIPTION_REJECTED: {
			return state;
		}
		// ADD
		case Keys.ADDCONTACTSUBSCRIPTION_PENDING: {
			return state;
		}
		case Keys.ADDCONTACTSUBSCRIPTION_FULFILLED: {
			let p: contactSubscription = action.payload; // sanifyContact();

			let cSubscriptions = []
			if (state.contactSubscriptions !== undefined) {
				cSubscriptions = [...state.contactSubscriptions];
			}
			cSubscriptions.push(p);

			return {
				...state,
				contactSubscriptions: cSubscriptions,
			}
		}
		case Keys.ADDCONTACTSUBSCRIPTION_REJECTED: {
			return state;
		}

		// MEDICAL - DELETE FROM CONTACT
		case Keys.DELETECONTACTMEDICAL_PENDING: {
			return state;
		}
		case Keys.DELETECONTACTMEDICAL_FULFILLED: {
			let saved: { id: string, deleted: boolean } = action.payload;
			let cMedical = [...state.contactMedical];
			if (saved.deleted) {
				let found = cMedical.findIndex(c => c._id === saved.id);
				if (found >= 0) {
					cMedical.splice(found, 1);
				}
			}
			return {
				...state,
				contactMedical: cMedical,
			}
		}
		case Keys.DELETECONTACTMEDICAL_REJECTED: {
			return state;
		}
		// SAVE
		case Keys.SAVECONTACTMEDICAL_PENDING: {
			return state;
		}
		case Keys.SAVECONTACTMEDICAL_FULFILLED: {
			let p: contactMedicalExamination = action.payload;
			let cMedical = [...state.contactMedical];
			let found = cMedical.findIndex(c => c._id === p._id);
			if (found >= 0) {
				cMedical[found] = p;
			}
			return {
				...state,
				contactMedical: cMedical,
			}
		}
		case Keys.SAVECONTACTMEDICAL_REJECTED: {
			return state;
		}
		// ADD
		case Keys.ADDCONTACTMEDICAL_PENDING: {
			return state;
		}
		case Keys.ADDCONTACTMEDICAL_FULFILLED: {
			let p: contactMedicalExamination = action.payload; // sanifyContact();

			let cMedical = []
			if (state.contactMedical !== undefined) {
				cMedical = [...state.contactMedical];
			}
			cMedical.push(p);

			return {
				...state,
				contactMedical: cMedical,
				isLoading: false,
				// .... XXXXXXXXXXXXXXXXXXX
			}
		}
		case Keys.ADDCONTACTMEDICAL_REJECTED: {
			return state;
		}

		// INSURANCE - LOAD CONTACT
		case Keys.DELETECONTACTINSURANCE_PENDING: {
			return state;
		}
		case Keys.DELETECONTACTINSURANCE_FULFILLED: {
			let saved: { id: string, deleted: boolean } = action.payload;
			let cInsurances = [...state.contactInsurances];
			if (saved.deleted) {
				let found = cInsurances.findIndex(c => c._id === saved.id);
				if (found >= 0) {
					cInsurances.splice(found, 1);
				}
			}
			return {
				...state,
				contactInsurances: cInsurances,
			}
		}
		case Keys.DELETECONTACTINSURANCE_REJECTED: {
			return state;
		}
		// SAVE
		case Keys.SAVECONTACTINSURANCE_PENDING: {
			return state;
		}
		case Keys.SAVECONTACTINSURANCE_FULFILLED: {
			let p: contactInsurance = action.payload;
			let cInsurance = [...state.contactInsurances];
			let found = cInsurance.findIndex(c => c._id === p._id);
			if (found >= 0) {
				cInsurance[found] = p;
			}
			return {
				...state,
				contactInsurances: cInsurance,
			}
		}
		case Keys.SAVECONTACTINSURANCE_REJECTED: {
			return state;
		}
		// ADD
		case Keys.ADDCONTACTINSURANCE_PENDING: {
			return state;
		}
		case Keys.ADDCONTACTINSURANCE_FULFILLED: {
			let p: contactInsurance = action.payload; // sanifyContact();

			let cInsurances = []
			if (state.contactInsurances !== undefined) {
				cInsurances = [...state.contactInsurances];
			}
			cInsurances.push(p);

			return {
				...state,
				contactInsurances: cInsurances,
				isLoading: false,
				// contactSubscriptions: cSubscriptions,
			}
		}
		case Keys.ADDCONTACTINSURANCE_REJECTED: {
			return state;
		}


		case Keys.LOADSUBSCRIPTIONS_PENDING: {
			return {
				...state,
				subscriptions: [],
				isLoading: true,
			}
		}
		case Keys.LOADSUBSCRIPTIONS_FULFILLED: {
			let p: Array<subscription> = action.payload;
			return {
				...state,
				subscriptions: p,
				isLoading: false,
			}
		}
		case Keys.LOADSUBSCRIPTIONS_REJECTED: {
			return {
				...state,
				subscriptions: [],
				isLoading: false,
			}
		}
		case Keys.LOADSUBSCRIPTION_PENDING: {
			return {
				...state,
				selectedSubscription: undefined,
				isLoadingSubscriptions: true,
			}
		}
		case Keys.LOADSUBSCRIPTION_FULFILLED: {
			let p: subscription = action.payload;
			return {
				...state,
				selectedSubscription: p,
				isLoadingSubscriptions: false,
			}
		}
		case Keys.LOADSUBSCRIPTION_REJECTED: {
			return {
				...state,
				selectedSubscription: undefined,
				isLoadingSubscriptions: false,
			}
		}
		case Keys.ADDSUBSCRIPTION_PENDING: {
			return state;
		}
		case Keys.ADDSUBSCRIPTION_FULFILLED: {
			let p: subscription = action.payload; // sanifyContact();

			let subscriptions = [...state.subscriptions];
			subscriptions.push(p);

			return {
				...state,
				selectedSubscription: p,
				subscriptions: subscriptions,
			}
		}
		case Keys.ADDSUBSCRIPTION_REJECTED: {
			return state;
		}
		case Keys.NEWSUBSCRIPTION: {
			let p: subscription = action.payload;
			return {
				...state,
				selectedSubscription: p,
				isLoading: false,
				isLoadingSubscriptions: false,
			}
		}
		case Keys.SAVESUBSCRIPTION_PENDING: {
			return state;
		}
		case Keys.SAVESUBSCRIPTION_FULFILLED: {
			let p: subscription = action.payload; // sanifyContact();
			let subscription = [...state.subscriptions];
			let found = subscription.findIndex(c => c._id === p._id);
			if (found >= 0) {
				subscription[found] = p;
			}
			// else {
			//     reminders.push(p);
			// }
			return {
				...state,
				selectedSubscription: p,
				subscriptions: subscription,
			}
		}
		case Keys.SAVESUBSCRIPTION_REJECTED: {
			return state;
		}
		default:
			return state;
	}
}